const basicMapVar = document.querySelector('[data-target="flatMap"]');
const mapKey = 'AIzaSyAL_F4Lug05Rc-FcdQCktz0YKX-uNqCnU8';

if (basicMapVar) {
    let s = document.createElement('script');
    s.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${mapKey}&v=beta&libraries=marker&callback=initMapSingle`);
    s.async = true;
    s.defer = true;
    document.body.appendChild(s);
    let map;


    function initMapSingle() {

        const coordinates = basicMapVar.getAttribute('data-coordinates')
        const nameOnMap = basicMapVar.getAttribute('data-name')

        let coord = coordinates.split(',');

        map = new google.maps.Map(basicMapVar, {
            center: {lat: parseFloat(coord[0]), lng: parseFloat(coord[1])},
            zoom: 15,
            mapId: 'a2f773bfed0b12f1'
        });

        /* const markerViewWithText = new google.maps.Marker({ 
             map,
             position: {lat: parseFloat(coord[0]), lng: parseFloat(coord[1])},
             title: nameOnMap,
         });*/

        const nameTag = document.createElement("div");

        nameTag.className = "name-tag";
        nameTag.innerHTML = `<div class="map-icon-single"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 6.09524V2.28571L8 0V3.80952L0 6.09524Z" fill="#15803D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.211 9.90483V6.09538L8.00049 4.95252V8.76198V8.76205V12.1905V12.5715V16.0001L12.211 14.8572V13.7144L12.211 11.0477L12.211 9.9049V9.90483Z" fill="#16A34A"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.79004 9.90471V6.09519L8.00058 4.95233V8.76186L3.79004 9.90471ZM3.79004 11.0477V9.90483L8.00058 8.76197L8.00058 12.1905L8.00058 12.5715V16.0001L3.79004 14.8572V13.7144V11.0477Z" fill="#15803D"/>
<path d="M16 6.09524V2.28571L8 0V3.80952L16 6.09524Z" fill="#16A34A"/>
</svg> ${nameOnMap}
</div>`;

        const markerView = new google.maps.marker.AdvancedMarkerView({
            map,
            position: {lat: parseFloat(coord[0]), lng: parseFloat(coord[1])},
            content: nameTag,
        });

        /*map.addListener('click',(e)=>{
            console.log(e);
            markerViewWithText.setPosition(e.latLng);
        })*/

        /*const priceTag = document.createElement("div");

        priceTag.className = "price-tag";
        priceTag.textContent = "$2.5M";

        const markerView = new google.maps.marker.AdvancedMarkerView({
            map,
            position: {lat: parseFloat(coord[0]), lng: parseFloat(coord[1])},
            content: priceTag,
        });*/


    }
    window.initMapSingle = initMapSingle;
}



/*
const basicMapVar = document.querySelector('[data-target="flatMap"]');
if (basicMapVar) {
    const coordinates = basicMapVar.getAttribute('data-coordinates')
    const map = L.map(basicMapVar).setView(coordinates.split(','), 13);

    const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    const marker = L.marker(coordinates.split(','));
    marker.addTo(map);

    // new L.Marker(coordinates.split(','), {
    //     icon: new L.DivIcon({
    //         className: 'my-div-icon',
    //         html: '<img class="my-div-image" src="http://png-3.vector.me/files/images/4/0/402272/aiga_air_transportation_bg_thumb"/>'+
    //             '<span class="my-div-span">RAF Banff Airfield</span>'
    //     })
    // });

   // if (document.getElementById('coordinates') &&
   //      document.getElementById('coordinates').value.length > 0) {
   //      let coordinates = document.getElementById('coordinates').value;
   //      marker.setLatLng(coordinates.split(','))
   //      marker.addTo(map);
   //  }
   //
   //  function onMapClick(e) {
   //      marker.setLatLng(e.latlng).addTo(map);
   //      if (document.getElementById('coordinates'))
   //          document.getElementById('coordinates').value = e.latlng.lat + "," + e.latlng.lng;
   //  }
   //
   //  map.on('click', onMapClick);

}
*/
